/**
 * ComingOnline.tsx — graceful panel for gateway routes that are rolling out
 *
 * Purpose:    When a /v1 route responds 404/405/501 (isComingOnline), the
 *             feature exists in the SPA but its backend route has not shipped
 *             yet. Render an informative "coming online" card instead of a
 *             scary error — never a crash, never fake data.
 * Inputs:     feature — human name of the surface; description — optional
 *             one-liner of what will appear here.
 * Outputs:    Static informational panel (no retry spam; user can navigate away)
 * Constraints: Dark-first styling; WCAG AA
 * SOT:        nsentry SaaS completion spec § G-WEB (coming-online contract)
 */

export function ComingOnline({ feature, description }: { feature: string; description?: string }) {
  return (
    <div className="mx-auto max-w-md rounded-xl border border-sky-200 dark:border-sky-800/60 bg-sky-50 dark:bg-sky-950/30 p-6 text-center" role="status">
      <p className="mb-1 text-sm font-semibold uppercase tracking-wide text-sky-700 dark:text-sky-400">Coming online</p>
      <p className="text-brand-secondary">
        {feature} is rolling out to your workspace. This panel lights up automatically — no action needed.
      </p>
      {description && <p className="mt-2 text-sm text-brand-muted">{description}</p>}
    </div>
  )
}
